export const CACHE_KEYS = {
  FILTERED_TRANSACTIONS: "transactions",
  ALL_TRANSACTIONS: "all-transactions",
  ALL_CURRENT_ACCOUNT_TRANSACTIONS: "all-current-account-transactions",
  ALL_CATEGORIES: "all-categories",
  CURRENT_USER_ACCOUNTS: "user-accounts",
  CURRENT_USER: "current-user",
  ALL_INVITES: "all-invites",
  ALL_USERS: "all-users",
  CURRENT_USER_NOTES: "user-notes",
  ALL_SOURCES: "all-sources",
  ALL_LOANS: "all-loans",
  ALL_FREQUENT_TRANSACTIONS: "all-frequent-transactions",
};
